<ul>
  <li *ngFor="let menu of menus" class="mega-menu-column">
    <span class="mega-menu-title text-uppercase" *ngIf="menu.title">
      <i class="fa fa-{{groupIcon(menu.title)}} mm-group-ico" aria-hidden="true"></i>
      <span>{{menu.title | translate}}</span>
    </span>
    <ul class="mega-menu-items">

      <li routerLinkActive='active' *ngFor="let m of menu.menu">
        <a routerLink="/app/{{m.route}}" routerLinkActive="active">
          <i class="fa fa-{{iconFor(m)}} menu-ico" aria-hidden="true"></i>
          <span style="font-weight:normal">{{m.text | translate}}</span>
        </a>
      </li>

    </ul>
  </li>
</ul>
